import styled from 'styled-components';

const Text = styled.div`
  width: 100%;
  flex: 1;
`;

export default Text;
